import { defineStore } from "pinia";

export const useEvaluationDirectoryStore = defineStore('evaluationDirectory', {
    state: () => ({
        evaluationDirectory: {},
        evaluationDirectories: [],
    }),
    actions: {
        setEvaluationDirectory(evaluationDirectory) {
            this.evaluationDirectory = evaluationDirectory
        },
        setEvaluationDirectories(evaluationDirectories) {
            this.evaluationDirectories = evaluationDirectories
        },
        addEvaluationDirectory(evaluationDirectory) {
            this.evaluationDirectories.unshift(evaluationDirectory)
        },
        updateEvaluationDirectory(evaluationDirectory) {
            let index = this.evaluationDirectories.findIndex(cl => cl.id === evaluationDirectory.id)
            this.evaluationDirectories.splice(index, 1, evaluationDirectory)
        },
        deleteEvaluationDirectory(evaluationDirectory) {
            let index = this.evaluationDirectories.findIndex(cl => cl.id === evaluationDirectory.id)
            this.evaluationDirectories.splice(index, 1)
        },
    },
});